import React from 'react';
import { Icon, Tooltip } from '@blueprintjs/core';
import { IconName, IconNames } from '@blueprintjs/icons';
import { DataSyncHealthStatus } from '../../../types/DataSyncMetrics';
import styles from './HealthIndicator.module.sass';

interface HealthIndicatorProps {
  status: DataSyncHealthStatus;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

const tooltipByStatus: Record<DataSyncHealthStatus, string> = {
  [DataSyncHealthStatus.HEALTHY]: '',
  [DataSyncHealthStatus.WARNING]: 'The sync is active, but some records failed to import. Click to view error details.',
  [DataSyncHealthStatus.FAILING]: 'The sync is active, but a significant number of records failed to import. Click to view error details.',
};

const iconClassByStatus: Record<DataSyncHealthStatus, string> = {
  [DataSyncHealthStatus.HEALTHY]: '',
  [DataSyncHealthStatus.WARNING]: styles.warning,
  [DataSyncHealthStatus.FAILING]: styles.failing,
};

const iconByStatus: Record<DataSyncHealthStatus, IconName> = {
  [DataSyncHealthStatus.HEALTHY]: IconNames.TICK,
  [DataSyncHealthStatus.WARNING]: IconNames.WARNING_SIGN,
  [DataSyncHealthStatus.FAILING]: IconNames.ISSUE,
};

const HealthIndicator: React.FC<HealthIndicatorProps> = ({ status, onClick }) => {
  if (status === DataSyncHealthStatus.HEALTHY) {
    return null;
  }

  return (
    <Tooltip content={tooltipByStatus[status]} hoverOpenDelay={120}>
      <button
        type="button"
        className={styles.iconButton}
        onClick={onClick}
      >
        <span className={styles.iconWrap}>
          <Icon icon={iconByStatus[status]} className={iconClassByStatus[status]} />
        </span>
      </button>
    </Tooltip>
  );
};

export default HealthIndicator;
